// extracted by mini-css-extract-plugin
export var active = "_hl-2";
export var recordingDot = "_hl-1";
export var recordingIndicator = "_hl-0";